<template>
<div class="score-singing">
    <div class="score-singing-original">
        <div v-for="(notes, beat) in phrase" :key="'Beat-' + beat" :id="'Beat-' + beat" :class="'beat beat-' + beat">
            <div class="beat-score beat-singing">
                <div v-for="(note, index) in notes['notes']" :key="'Note-' + index" :id="'Note-' + index" class="note-singing">
                    <img v-show="note[1] !== 'R'" :src="require('@/assets/figures-b/barrigas/fig-' + note[0].split('.')[0] + '.png')" />
                </div>
            </div>
        </div>
        <div v-for="(notes, beat) in phrase" :key="'Beat-Lyc-' + beat" :id="'Beat-Lyc-' + beat" class="beat-sing">
            <div class="lyc-score">
                <div v-for="(note, index) in notes['notes']" :key="'Note-Lyc-' + index" :id="'Note-Lyc-' + index">
                    <div v-for="(lyc, i_lyc) in note[note.length - 1]" :key="'Lyc-' + index + '-' + i_lyc" :id="'Lyc-' + index + '-' + i_lyc" class="note-singing lyrics">
                        <!--{{note[note.length - 1]}}-->
                        <div :id="'Lyric-' + i_lyc" class="lyric-singing"> {{lyc}} </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
//import VueLottiePlayer from "vue-lottie-player";

export default {
    name: 'PhraseDisplay',
    components: {
        //VueLottiePlayer
    },
    props: {
        phrase: Object,
        levels: Object,
    },
    data() {
        return {
            beat_changed: 0,
            muted: false
        }
    },
    methods: {}
}
</script>

<style>
.score-singing {
    width: 100%;
    display: flex;
    /*justify-items: start;
    align-items: start;*/
}

.score-singing-original {
    width: 100%;
    display: flex;
}

.beat-score {
    /*border: solid 1px coral;*/
    width: 70%;
    display: flex;
    justify-items: center;
    align-items: center;
}

.lyc-score {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-content: center;
    align-items: center
}

.note-singing {
    margin: 0-0.8rem;
}

.note-singing.lyrics {
    display: inline-block;
    margin-left: 1rem !important;
}

.note-singing>img {
    width: 5rem;
}

.lyric-singing {
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
    font-size: 1.5rem;

    color: #ffffff;
    text-align: center;
    vertical-align: middle;
}

.choose-singing {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 3.2em;
    padding: 0.65em 0.9em;
}
/*
.instrument {
    display: flex;
    justify-content: flex-start;

    margin-top: 1.8em;
}

.instrument-selector {

    border-radius: 50%;


    display: flex;
    justify-content: space-around;

    margin-left: 1em;
    z-index: 1;
}

.instrument-selector:active {
    background: red;
}
 */
.filter-green {
    filter: invert(48%) sepia(72%) saturate(463%) hue-rotate(67deg) brightness(96%) contrast(89%);
}

.filter-magenta {
    filter: invert(16%) sepia(96%) saturate(7410%) hue-rotate(320deg) brightness(91%) contrast(102%);
}

.filter-white {
    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(26deg) brightness(103%) contrast(101%);
}

.filter-yellow {
    filter: invert(65%) sepia(80%) saturate(475%) hue-rotate(2deg) brightness(108%) contrast(94%);
}



.instrument-mute {
    background: chartreuse;
    opacity: 8.0;
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    width: 1.5em;
    height: 1.5em;

    margin-left: -1em;
    margin-top: 2em;
    z-index: 2;
}

.instrument-mute.muted {
    background: red;
}

.instrument-mute>img {
    width: 0.75em;
}

@media only screen and(max-width: 480 px) {
    .choose-singing {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-singing {
        margin: 0-0.7rem;
    }

    .note-singing>img {
        width: 2rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .beat-singing {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-singing {
        margin: 0-0.7rem;
    }

    .note-singing>img {
        width: 2.8rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .beat-singing {
        padding: 0.6rem;
        border-radius: 9px;
    }

    .note-singing {
        margin: 0-0.8rem;
    }

    .note-singing>img {
        width: 3rem;
    }

    .hidden-melody {
        height: 4rem;
        width: 1.4rem;
    }
}

@media only screen and(min-width: 550px) and(max-width: 630px) {
    .beat-singing {
        padding: 0.7rem;
        border-radius: 10px;
    }

    .note-singing {
        margin: 0-0.9rem;
    }

    .note-singing>img {
        width: 3.4rem;
    }

    .hidden-melody {
        height: 4.3rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 630px) and(max-width: 718px) {
    .beat-singing {
        padding: 0.8rem;
        border-radius: 11px;
    }

    .note-singing {
        margin: 0-1rem;
    }

    .note-singing>img {
        width: 3.6rem;
    }

    .hidden-melody {
        height: 4.6rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 718 px) and(max-width: 806 px) {
    .beat-singing {
        padding: 0.9rem;
        border-radius: 12px;
    }

    .note-singing {
        margin: 0-1.1rem;
    }

    .note-singing>img {
        width: 4rem;
    }

    .hidden-melody {
        height: 5.1rem;
        width: 1.7rem;
    }
}

@media only screen and(min-width: 806 px) and(max-width: 1024 px) {
    .beat-singing {
        padding: 1rem;
        border-radius: 13px;
    }

    .note-singing {
        margin: 0-1.2rem;
    }

    .note-singing>img {
        width: 4.4rem;
    }

    .hidden-melody {
        height: 5.5rem;
        width: 2rem;
    }
}
@media only screen and(min-width: 718 px) {
    .lyric-singing {
        font-size: 3rem !important;
    }
}

@media only screen and(min-width: 1024 px) and(max-width: 1200 px) {
    .beat-singing {
        padding: 1.2 rem;
        border-radius: 14 px;
    }

    .note-singing {
        margin: 0-1.5 rem;
    }

    .note-singing>img {
        width: 6 rem;
    }

    .hidden-melody {
        height: 7.5 rem;
        width: 2.9 rem;
    }
}

@media only screen and(min-width: 1200 px) and(max-width: 1366 px) {
    .beat-singing {
        padding: 1.4 rem;
        border-radius: 15 px;
    }

    .note-singing {
        margin: 0-1.7 rem;
    }

    .note-singing>img {
        width: 6.6 rem;
    }

    .hidden-melody {
        height: 8.2 rem;
        width: 3.1 rem;
    }
}

@media only screen and(min-width: 1366 px) and(max-width: 1540 px) {
    .beat-singing {
        padding: 1.6 rem;
        border-radius: 16 px;
    }

    .note-singing {
        margin: 0-1.9 rem;
    }

    .note-singing>img {
        width: 7.4 rem;
    }

    .hidden-melody {
        height: 9.2 rem;
        width: 3.3 rem;
    }
}

@media only screen and(min-width: 1540 px) and(max-width: 1680 px) {
    .beat-singing {
        padding: 1.8 rem;
        border-radius: 20 px;
    }

    .note-singing {
        margin: 0-2 rem;
    }

    .note-singing>img {
        width: 8.5 rem;
    }

    .hidden-melody {
        height: 10.5 rem;
        width: 4 rem;
    }
}

@media only screen and(min-width: 1680 px) and(max-width: 2350 px) {
    .beat-singing {
        padding: 2 rem;
        border-radius: 25 px;
    }

    .note-singing {
        margin: 0-2.3 rem;
    }

    .note-singing>img {
        width: 9.3 rem;
    }

    .hidden-melody {
        height: 11.5 rem;
        width: 4.7 rem;
    }
}

@media only screen and(min-width: 2350 px) {
    .buttons-melody>div {
        width: 5.4 rem;
    }

    .lateral-melody {
        width: 5.3 rem;
    }

    .beat-singing {
        padding: 2.2 rem;
        border-radius: 30 px;
    }

    .note-singing {
        margin: 0-3 rem;
    }

    .note-singing>img {
        width: 13 rem;
    }

    .hidden-melody {
        height: 16 rem;
        width: 7.2 rem;
    }
}
</style>
